const state = {
  permissions: {}
}

const mutations = {
  updatePermissions (state, obj) {
    state.permissions = obj.permissions
  }
}

const actions = {
  async getPermissions () {
    let objResp = {}
    let profId = await JSON.parse(localStorage.getItem('userData')).profile_id
    let obj = {
      url: '/api/permissionUser/' + profId,
      query: '',
      method: 'post',
      noLoader: true
    }

    await this.dispatch('request/doRequest', obj).then(resp => {
      objResp = { permissions: resp.data.permissions }
      this.commit('permissions/updatePermissions', objResp)
    })

    return objResp
  }
}

export default {
  namespaced: true,
  root: true,
  actions,
  mutations,
  state
}
